import React, { useEffect, useState } from 'react'
import { Button, Result, Spin, message } from 'antd'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import styles from './index.module.scss'
import { editWechatInfo } from '../../../store/actions/user'
import { closeWin } from '../../../utils/closewin'
import {
  WECHAT_QR_EXPIRED_CODE,
  createWechatInfoParams,
} from '../../../utils/wechatQr'

export default function BindWxPage() {
  const dispatch = useDispatch()
  const { scan_id: scanId } = useParams()
  const [loading, setLoading] = useState(true)
  const [success, setSuccess] = useState(false)
  const [expired, setExpired] = useState(false)

  useEffect(() => {
    document.title = '授权绑定'
    const params = createWechatInfoParams(scanId, window.location.search)
    if (!params.scan_id || !params.code || !params.state) {
      setExpired(true)
      setLoading(false)
      return undefined
    }

    let active = true
    dispatch(editWechatInfo(params, false))
      .then((res) => {
        if (!active) return
        if (res.data.code === 0) {
          setSuccess(true)
          message.success('绑定成功')
        } else if (res.data.code === WECHAT_QR_EXPIRED_CODE) {
          setExpired(true)
        } else {
          message.error(res.data.msg)
        }
        setLoading(false)
      })
      .catch((error) => {
        if (!active) return
        if (error?.response?.data?.code === WECHAT_QR_EXPIRED_CODE) {
          setExpired(true)
        }
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [dispatch, scanId])

  return (
    <div className={styles.root}>
      <div className="content_div" id="conId">
        {loading ? (
          <Spin size="large" />
        ) : success ? (
          <Result
            status="success"
            title="微信绑定成功"
            extra={<Button onClick={closeWin}>完成</Button>}
          />
        ) : (
          <Result title={expired ? '二维码已过期，请重新扫码' : '微信绑定失败'} />
        )}
      </div>
    </div>
  )
}
